import { NavLink } from "react-router-dom";
import { useState } from "react";

function Sidebar() {

    const [open, setOpen] = useState(false);

    const menus = [
        { title: "داشبورد", icon: "🏠", path: "/dashboard" },
        { title: "بازی‌ها", icon: "🎮", path: "/games" },
        { title: "شارژ", icon: "🔋", path: "/Charge" },
        { title: "گزارش‌ها", icon: "📊", path: "/reports" },
        { title: "وضعیت دستگاه", icon: "📡", path: "/devices" },
        { title: "تنظیمات", icon: "⚙️", path: "/settings" }
    ];

    return (
        <>
            {/* دکمه همبرگری - فقط موبایل */}
            <button
                onClick={() => setOpen(true)}
                className="
                    md:hidden
                    fixed
                    top-5
                    right-5
                    z-50
                    bg-orange-500
                    text-white
                    w-12
                    h-12
                    rounded-xl
                    text-2xl
                    shadow-lg
                "
            >
                ☰
            </button>

            {/* پس زمینه تیره */}
            {open && (
                <div
                    onClick={() => setOpen(false)}
                    className="
                        md:hidden
                        fixed
                        inset-0
                        bg-black/60
                        z-40
                    "
                />
            )}

            {/* Sidebar */}
            <aside
                className={`
                    fixed
                    top-0
                    right-0
                    h-screen
                    w-72
                    bg-slate-950
                    border-l
                    border-slate-800
                    z-50
                    transform
                    transition-transform
                    duration-300

                    ${open ? "translate-x-0" : "translate-x-full"}

                    md:translate-x-0
                    md:static
                    md:w-64`
                }
            >
                {/* Header */}
                <div className="p-6 border-b border-slate-800 flex items-center justify-between">

                    <div>
                        <h2 className="text-cyan-400 text-2xl font-black">
                            Mega<span className="text-orange-500">Games</span>
                        </h2>

                        <p className="text-gray-500 text-sm mt-1">
                            پنل مدیریت
                        </p>
                    </div>

                    <button
                        className="md:hidden text-white text-2xl"
                        onClick={() => setOpen(false)}
                    >
                        ✕
                    </button>

                </div>

                {/* Menu */}
                <nav className="mt-6 px-4">

                    {menus.map((item) => (

                        <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={() => setOpen(false)}
                            className={({ isActive }) =>
                                `
                                flex
                                items-center
                                gap-4
                                px-4
                                py-4
                                rounded-2xl
                                mb-2
                                transition

                                ${
                                    isActive
                                        ? "bg-orange-500 text-white"
                                        : "text-gray-300 hover:bg-slate-800 hover:text-cyan-400"}
                                `
                            }
                        >
                            <span className="text-xl">
                                {item.icon}
                            </span>

                            <span className="font-medium">
                                {item.title}
                            </span>
                        </NavLink>

                    ))}

                </nav>

            </aside>
        </>
    );
}

export default Sidebar;
